// tslint:disable
import { cssRule } from 'typestyle';
import * as csstips from 'csstips'

cssRule('.mainactive__coupon', {
    "width": "100%",
    "height": "100vh",
    "position": "fixed",
    "left": 0,
    "right": 0,
    "top": 0,
    "bottom": 0,
    "backgroundColor": "rgba(0, 0, 0, 0.75)",
    ...csstips.flexRoot,
    ...csstips.vertical,
    ...csstips.centerJustified,
    ...csstips.center,
    "zIndex": 100
});
cssRule('.mainactive__coupon .fixedTheCloseBtn', {
    "position": "fixed",
    "maxWidth": "480px",
    "height": "50px",
    "width": "100%",
    "top": 0
});
cssRule('.mainactive__coupon .coupon__img', {
    "width": "calc(100vw * 300 / 375)",
    "maxWidth": "320px",
    "cursor": "pointer",
    "animation": "boom_main 1s forwards",
    "position": "relative"
});
cssRule('.mainactive__coupon .coupon__img img', {
    "width": "100%",
    "margin": 0,
    "borderRadius": "5px"
});
cssRule('.mainactive__coupon .coupon__close', {
    "opacity": 1,
    "width": "30px",
    "height": "30px",
    "position": "absolute",
    "right": "0",
    "top": "-45px",
    "transition": "1s all"
});
cssRule('.mainactive__coupon .coupon__close img', {
    "width": "100%",
    "margin": 0
});
cssRule('@keyframes boom_main', {
    "$nest": {
        "0%": {
            "transform": "scale(1, 1)"
        },
        "60%": {
            "transform": "scale(1.2, 1.2)"
        },
        "80%": {
            "transform": "scale(0.8, 0.8)"
        },
        "100%": {
            "transform": "scale(1, 1)"
        }
    }
});


// WEBPACK FOOTER //
// ./src/views/Home/components/HomeActiveCoupon/HomeActiveCouponStyle.ts